import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META, { type CompletedOnboardingInviteMembersRole } from './useTrackCompletedOnboardingInviteMembers.meta';

export type { CompletedOnboardingInviteMembersRole } from './useTrackCompletedOnboardingInviteMembers.meta';

export type UseTrackCompletedOnboardingInviteMembersParams = WithOnboardingAnalyticsCategory<{
  role: CompletedOnboardingInviteMembersRole;
  number_invites: number;
}>;

export const useTrackCompletedOnboardingInviteMembers = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingInviteMembers = useCallback(
    (params: UseTrackCompletedOnboardingInviteMembersParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackCompletedOnboardingInviteMembers };
};
